import { useEffect, useState } from 'react';
import { Container, Row, Col, Card, Image } from 'react-bootstrap';
import CountdownBadge from './components/CountdownBadge';

import NewsletterRibbon from './components/NewsletterRibbon';

const organizers = [
  { src: 'img-sponsors/sponsors_gaef.webp', alt: 'Gesellschaft für Aerosolforschung' },
  { src: 'img-sponsors/sponsors_ung.webp', alt: 'University of Nova Gorica' },
  { src: 'img-sponsors/sponsors_ki.webp', alt: 'National Institute of Chemistry' },
  { src: 'img-sponsors/sponsors_jsi.webp', alt: 'Jožef Stefan Institute' },
  { src: 'img-sponsors/sponsors_aerosol.webp', alt: 'Aerosol Magee Scientific' },
  { src: 'img-sponsors/sponsors_aethlabs.webp', alt: 'Aethlabs' },
];

function CountUp({ end, suffix = '', duration = 2400 }) {
  const [count, setCount] = useState(0);

  useEffect(() => {
    let frameId;
    const startTime = performance.now();

    const animate = (currentTime) => {
      const progress = Math.min((currentTime - startTime) / duration, 1);
      const easedProgress = 1 - Math.pow(1 - progress, 5);

      setCount(Math.round(end * easedProgress));

      if (progress < 1) {
        frameId = requestAnimationFrame(animate);
      }
    };

    frameId = requestAnimationFrame(animate);

    return () => cancelAnimationFrame(frameId);
  }, [end, duration]);

  return (
    <>
      {count}
      {suffix}
    </>
  );
}

export default function Home() {
  return (
    <div className="home-page">
      <section
        id="home"
        className="hero-section vh-100 d-flex flex-column bg-eac-blue"
        style={{ paddingTop: '80px' }}
      >
        <Container className="d-flex flex-grow-1 align-items-center">
          <Row className="align-items-center w-100">
            <Col md={12} lg={12}>
              <CountdownBadge targetDate="2027-09-06T09:00:00+02:00" />

              <h1 className="display-3 fw-bold text-white hero-title">
                Welcome to <span>EAC2027</span>
              </h1>

              <p className="lead mt-3 mb-4 text-eac-grey lh-3">
                Join us at the European Aerosol Conference in{' '}
                <span className="text-marker text-white">
                  Ljubljana, Slovenia, 5<sup>th</sup> to 10<sup>th</sup>{' '}
                  September 2027.
                </span>
              </p>

              <Row
                className="hero-stats row-cols-lg-5 g-0 mt-5 d-none d-lg-flex"
                aria-label="EAC2027 key figures"
              >
                <Col>
                  <div className="hero-stat">
                    <span className="hero-stat-number">
                      <CountUp end={5} />
                    </span>
                    <span className="hero-stat-label">Research directions</span>
                  </div>
                </Col>

                <Col>
                  <div className="hero-stat">
                    <span className="hero-stat-number">
                      <CountUp end={40} suffix="+" />
                    </span>
                    <span className="hero-stat-label">Topics</span>
                  </div>
                </Col>

                <Col>
                  <div className="hero-stat">
                    <span className="hero-stat-number">
                      <CountUp end={1000} suffix="+" />
                    </span>
                    <span className="hero-stat-label">Participants</span>
                  </div>
                </Col>

                <Col>
                  <div className="hero-stat">
                    <span className="hero-stat-number">
                      <CountUp end={370} suffix="+" />
                    </span>
                    <span className="hero-stat-label">Talks</span>
                  </div>
                </Col>

                <Col>
                  <div className="hero-stat">
                    <span className="hero-stat-number">
                      <CountUp end={3} />
                    </span>
                    <span className="hero-stat-label">Poster sessions</span>
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>

        <div className="hero-news mt-auto">
          <Container>
            <div className="hero-news-inner">
              <i className="bi bi-bell-fill hero-news-icon" aria-hidden="true"></i>
              <span className="hero-news-label ms-2 me-2">News:</span>
              <div className="hero-news-links">
                <a href="https://www.linkedin.com/showcase/eac2027/posts/?feedView=all" target='_blank' rel='noreferrer' className="hero-news-link">
                  Follow us on LinkedIn and stay tuned
                </a>
                <span className="hero-news-separator" aria-hidden="true">
                  |
                </span>
                <a href="https://756b0975.sibforms.com/serve/MUIFAExUQ8BuBk-bI00pY3aLy2xdqWMPTqdQsszRekzMjGyX0LQC9Qnf31TB64baa4HXabH_vi6MjgOfuR0V8HaAk4eorGuSFw0x5lPeqZwDNmz7tNipgsYfh5OYS9DlHjvWkPVvCoY4G_hJQrd1tZe9XmMr2DeNxadBQyFd5F4xNYFi_RUMc5eqoZtkw6vh_pO3HCbPVlLTTkOR" target='_blank' rel='noreferrer' className="hero-news-link">
                  Subscribe to our official newsletter
                </a>
                <span className="hero-news-separator" aria-hidden="true">
                  |
                </span>

                <a href="/tentative-program" className="hero-news-link">
                  Tentative programme is now available
                </a>

                
                </div>
            </div>
          </Container>
        </div>
      </section>

      <main className="info-page pt-5 pb-5">
        <Container className="pt-4">
          <Row className="justify-content-center">
            <Col lg={10} xl={9}>
              <section id="welcome" className="info-section">
                <p className='small'>
                 Dear EAC2027 participants,
                </p>
                <h2 className="h1 mb-4">Welcome to Ljubljana!</h2>
                <p>
                  <span className="text-marker">Conferences are great.</span> Conferences are where{' '}
                  <span className="text-marker">ideas, collaborations, research directions</span> begin to take shape. Our goal is to create an environment
                  where all of this can happen—with plenty of fun along the way—throughout EAC2027.
                </p>

                <p>
                  You are coming to the right place at the right time. In only a few months, Ljubljana will once again provide a{' '}
                  <span className="text-marker">fascinating natural laboratory for aerosol research</span>. It will be
                  full of wood smoke, the almost 150,000 cars that drive to the city every day will spew out particulate matter and
                  gaseous precursors, primary emissions will become coated with secondary organics, and the meteorology will ensure that
                  long stagnant periods persist.
                </p>

                <p>
                  While challenges remain, Ljubljana is also a success story of{' '}
                  <span className="text-marker">local air-quality improvement</span>. It has served as
                  an aerosol laboratory for many years, and the effectiveness of abatement measures has been demonstrated through
                  measurements. Emissions have been measured on the roads, emission rates derived from ambient data, and physical
                  processes constrained using sophisticated ambient experimental setups.
                </p>

                <p>
                  <span className="text-marker">And now we host you.</span>
                </p>

                <p>
                  We look forward to hearing about what you have been recently doing, the results of your models, laboratory experiments
                  and ambient campaigns, and your development of new measurement techniques.{' '}
                  <span className="text-marker">Novel findings in aerosol research</span> will be
                  communicated and discussed at the conference, but certainly also over dinner or a beer after the formal programme has
                  ended for the day. We urge you to take advantage of Ljubljana’s vibrant atmosphere and venture a bit away from the
                  city centre. Fun awaits.
                </p>

             

                <p>
                  <span className="text-marker">Enjoy the conference, come back</span> in winter for the measurements!
                </p>
              </section>

              <NewsletterRibbon />

              <section id="important-dates" className="info-section d-none">
                <h2>Important dates</h2>

                <p>TBD</p>
              </section>

              <section id="organizers" className="info-section">
                <h2>Organizers</h2>

                <p>
                  EAC2027 is organized by the <a href="https://www.info.gaef.de/" target="_blank" rel="noreferrer">Gesellschaft für Aerosolforschung</a> in collaboration with the University of
                  Nova Gorica and a dedicated team from Slovenia supported by local institutions committed to
                  advancing aerosol science and fostering international collaboration.
                </p>

                <p>
                  <strong>Conference Chair:</strong> Ana Kroflič
                </p>

                
              </section>
            </Col>
          </Row>

          <Row className="py-5">
            {organizers.map((organizer, index) => (
              <Col lg="2" key={index}>
                <Card className="border rounded border-eac-blue p-3">
                  <Card.Body>
                    <Image src={organizer.src} alt={organizer.alt} className="img-fluid" />
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
          <Row>
            <Col>
              <p className='small'>Cover photo: Embankments of Ljubljanica river © Blaž Pogačar, <a href="https://www.visitljubljana.com/" target="_blank" rel="noreferrer">Ljubljana Tourism</a> photo library.</p>
            </Col>
          </Row>
        </Container>
      </main>
    </div>
  );
}